<!-- design-lint-disable form-uses-precognition (sign-in: a live check would tell a visitor which emails have accounts) -->
<script>
  import { useForm } from '@inertiajs/svelte'
  import FlashMessage from '../../components/flash_message.svelte'
  import LegacyCmsBanner from '../../components/legacy_cms_banner.svelte'
  import ZuppLogo from '../../components/zupp_logo.svelte'
  import { Button } from '../../components/ui'

  let { email = '' } = $props()

  const form = useForm({
    admin_site_admin: {
      email: email || '',
      password: '',
      remember_me: false
    }
  })

  function submit(e) {
    e.preventDefault()
    $form.post('/sign-in', {
      onFinish: () => {
        $form.admin_site_admin.password = ''
      }
    })
  }
</script>

<LegacyCmsBanner />
<div class="min-h-screen bg-base-200 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
  <FlashMessage />
  <div class="card bg-base-100 shadow-md p-8 w-full max-w-md space-y-8">
    <div class="text-center flex flex-col items-center gap-2">
      <ZuppLogo class="h-12 w-auto text-primary" />
    </div>

    <form novalidate onsubmit={submit} class="space-y-4">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Email</legend>
        <input
          type="email"
          bind:value={$form.admin_site_admin.email}
          class="input w-full"
          class:input-error={$form.errors.email}
          placeholder="Enter your email"
          autocomplete="email"
        />
        {#if $form.errors.email}
          <div class="text-error text-sm mt-1">{$form.errors.email[0]}</div>
        {/if}
      </fieldset>

      <fieldset class="fieldset">
        <legend class="fieldset-legend">Password</legend>
        <input
          type="password"
          bind:value={$form.admin_site_admin.password}
          class="input w-full"
          class:input-error={$form.errors.password}
          placeholder="Enter your password"
          autocomplete="current-password"
        />
        {#if $form.errors.password}
          <div class="text-error text-sm mt-1">{$form.errors.password[0]}</div>
        {/if}
      </fieldset>

      <label class="flex items-center gap-2">
        <input type="checkbox" bind:checked={$form.admin_site_admin.remember_me} class="checkbox checkbox-primary" />
        <span class="text-sm">Remember me</span>
      </label>

      <Button type="submit" variant="primary" block loading={$form.processing}>Log in</Button>
    </form>

    <div class="text-center text-sm">
      <a href="/forgot-password" class="link link-primary">Forgot your password?</a>
    </div>
  </div>
</div>
